import { render, staticRenderFns } from "./Patterns.vue?vue&type=template&id=8a403568"
import script from "./Patterns.vue?vue&type=script&lang=js"
export * from "./Patterns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports